import React from 'react';
import './css/Login.css';
import ReactHtmlParser from 'react-html-parser';
import CustomizedSnackbars from './Message';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import {confirmAlert} from 'react-confirm-alert';
function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'© '}
            {new Date().getFullYear()} {'allstardirectories.com. All rights reserved.'}{' '}
        </Typography>
    );
}

class CreateEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            asd_username: '',
            asd_password: '',
            asd_conf_password: '',
            asd_email: '',
            userrole: '',
            cost_type: '',
            asd_code: '',
            asd_firstname: '',
            asd_lastname: '',
            userId: '',
            inputLabel: '',
            error: {
                error_message: '',
            },
            success: {
                success_message: '',
            },
            currentuserrole: '',
            isAuthenticate: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.confirmSubmit = this.confirmSubmit.bind(this);

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleCancelSubmit = this.handleCancelSubmit.bind(this);
    }

    componentDidMount() {
        const inpersonateId = localStorage.getItem('inpersonate_id');
        let userId = localStorage.getItem('userId');
        let inpersonate = localStorage.getItem('inpersonate');
        const get_token = localStorage.getItem('token');
        let obj = {id: userId, token: get_token};
        obj.id = inpersonateId;
        this.setState({userId: inpersonateId});

        if (userId !== '' && userId !== null) {
            const requestOptions = {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(obj),
            };
            fetch(`./wp-json/asd/users/get`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.user_info !== false) {
                        this.setState({
                            asd_username: data.user_info.data.user_login,
                            asd_email: data.user_info.data.user_email,
                            userrole: data.user_role,
                            asd_code: data.user_code,
                            cost_type: data.cost_type,
                            asd_firstname: data.first_name,
                            asd_lastname: data.last_name,
                            currentuserrole: data.user_role,
                        });
                    } else {
                        window.location.href = './users';
                    }
                });
        }
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    handleSelectChange(event) {
        this.setState({userrole: event.target.value});
    }

    handleSelectCostTypeChange(event) {
        this.setState({cost_type: event.target.value});
    }

    handleCancelSubmit(event) {
        const userRole = localStorage.getItem('userRole');
        if ('1' === userRole && window.location.pathname != '/myaccount') {
            window.location.href = './users';
        } else {
            window.location.href = './';
        }
    }

    confirmSubmit(event) {
        event.preventDefault();
        let asd_firstname = this.state.asd_firstname.trim();
        let asd_lastname = this.state.asd_lastname.trim();
        let asd_username = this.state.asd_username.trim();
        let asd_password = this.state.asd_password.trim();
        let asd_conf_password = this.state.asd_conf_password.trim();
        let userrole = this.state.userrole;
        let asd_email = this.state.asd_email.trim();
        let asd_code = this.state.asd_code.trim();
        let cost_type = this.state.cost_type;
        const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/gim;
        if ('' === asd_username) {
            this.setState({
                error: {
                    error_message: 'Please Enter Username',
                },
            });
            return false;
        } else if ('' === asd_email || !emailRegex.test(asd_email)) {
            this.setState({
                error: {
                    error_message: 'Please enter a valid email address.',
                },
            });
            return false;
        } else if ('' === asd_code) {
            this.setState({
                error: {
                    error_message: 'Please Enter the Vendor Display Name',
                },
            });
            return false;
        } else if ('' !== asd_password || '' !== asd_conf_password) {
            if (asd_conf_password !== asd_password) {
                this.setState({
                    error: {
                        error_message: 'Password and confirm password does not match.',
                    },
                });
                return false;
            }
        } else {
            this.setState({
                error: {
                    error_message: '',
                },
            });
        }

        if (this.state.asd_password) {
            confirmAlert({
                message: 'Are you sure you want to update the password?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => {
                            const get_token = localStorage.getItem('token');
                            if (this.state.userId === '' || this.state.userId === null) {
                                const requestOptions = {
                                    method: 'POST',
                                    mode: 'cors',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Accept: 'application/json',
                                    },
                                    body: JSON.stringify({
                                        username: asd_username,
                                        password: asd_password,
                                        role: userrole,
                                        email: asd_email,
                                        first_name: asd_firstname,
                                        last_name: asd_lastname,
                                        user_code: asd_code,
                                        cost_type: cost_type,
                                    }),
                                };
                                fetch(`./wp-json/wp/v2/users/register`, requestOptions)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (200 !== data.code) {
                                            this.setState({
                                                error: {
                                                    error_message: data.message,
                                                },
                                            });
                                        } else {
                                            this.setState({
                                                success: {
                                                    success_message: data.message,
                                                },
                                            });

                                            this.setState({
                                                error: {
                                                    error_message: '',
                                                },
                                            });
                                            window.location.href = './users';
                                        }
                                    });
                            } else {
                                let obj = {
                                    userId: this.state.userId,
                                    get_token: get_token,
                                    username: asd_username,
                                    password: asd_password,
                                    email: asd_email,
                                    first_name: asd_firstname,
                                    last_name: asd_lastname,
                                    user_code: asd_code,
                                    cost_type: cost_type,
                                };
                                let inpersonate = localStorage.getItem('inpersonate');
                                let userRole = localStorage.getItem('userRole');

                                if (
                                    (inpersonate == 'true' &&
                                        'administrator' !== this.state.currentuserrole) ||
                                    userRole != 1
                                ) {
                                    obj.roles = '';
                                } else {
                                    obj.roles = userrole;
                                }
                                const requestOptionsEdit = {
                                    method: 'POST',
                                    mode: 'cors',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Accept: 'application/json',
                                        Authorization: 'Bearer ' + get_token,
                                    },
                                    body: JSON.stringify(obj),
                                };
                                fetch(`./wp-json/asd/users/update`, requestOptionsEdit)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.code !== 200) {
                                            this.setState({
                                                error: {
                                                    error_message: data.message,
                                                },
                                            });
                                        } else {
                                            this.setState({
                                                success: {
                                                    success_message: data.message,
                                                },
                                            });

                                            this.setState({
                                                error: {
                                                    error_message: '',
                                                },
                                            });

                                            const userRole = localStorage.getItem('userRole');
                                            if (
                                                '1' === userRole &&
                                                inpersonate !== 'true' &&
                                                window.location.pathname != '/myaccount'
                                            ) {
                                                window.location.href = './users';
                                            } else {
                                                window.location.href = './';
                                            }
                                        }
                                    });
                            }
                        },
                    },
                    {
                        label: 'No',
                        onClick: () => {
                            return false;
                        },
                    },
                ],
            });
        } else {
            const get_token = localStorage.getItem('token');
            if (this.state.userId === '' || this.state.userId === null) {
                const requestOptions = {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        username: asd_username,
                        password: asd_password,
                        role: userrole,
                        email: asd_email,
                        first_name: asd_firstname,
                        last_name: asd_lastname,
                        user_code: asd_code,
                        cost_type: cost_type,
                    }),
                };
                fetch(`./wp-json/wp/v2/users/register`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        if (200 !== data.code) {
                            this.setState({
                                error: {
                                    error_message: data.message,
                                },
                            });
                        } else {
                            this.setState({
                                success: {
                                    success_message: data.message,
                                },
                            });

                            this.setState({
                                error: {
                                    error_message: '',
                                },
                            });
                            window.location.href = './users';
                        }
                    });
            } else {
                let obj = {
                    userId: this.state.userId,
                    get_token: get_token,
                    username: asd_username,
                    password: asd_password,
                    email: asd_email,
                    first_name: asd_firstname,
                    last_name: asd_lastname,
                    user_code: asd_code,
                    cost_type: cost_type,
                };
                let inpersonate = localStorage.getItem('inpersonate');
                let userRole = localStorage.getItem('userRole');
                // if (inpersonate == 'true' && 'administrator' === this.state.currentuserrole) {

                // } else
                if (
                    (inpersonate == 'true' && 'administrator' !== this.state.currentuserrole) ||
                    userRole != 1
                ) {
                    obj.roles = '';
                } else {
                    obj.roles = userrole;
                }
                const requestOptionsEdit = {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + get_token,
                    },
                    body: JSON.stringify(obj),
                };
                fetch(`./wp-json/asd/users/update`, requestOptionsEdit)
                    .then(response => response.json())
                    .then(data => {
                        if (data.code !== 200) {
                            this.setState({
                                error: {
                                    error_message: data.message,
                                },
                            });
                        } else {
                            this.setState({
                                success: {
                                    success_message: data.message,
                                },
                            });

                            this.setState({
                                error: {
                                    error_message: '',
                                },
                            });
                            // localStorage.removeItem("inpersonate_id");

                            const userRole = localStorage.getItem('userRole');
                            if (
                                '1' === userRole &&
                                inpersonate !== 'true' &&
                                window.location.pathname != '/myaccount'
                            ) {
                                window.location.href = './users';
                            } else {
                                window.location.href = './';
                            }
                        }
                    });
            }
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        let asd_firstname = this.state.asd_firstname.trim();
        let asd_lastname = this.state.asd_lastname.trim();
        let asd_username = this.state.asd_username.trim();
        let asd_password = this.state.asd_password.trim();
        let asd_conf_password = this.state.asd_conf_password.trim();
        let userrole = this.state.userrole;
        let asd_email = this.state.asd_email.trim();
        let asd_code = this.state.asd_code.trim();
        let cost_type = this.state.cost_type;
        const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/gim;
        if ('' === asd_username) {
            this.setState({
                error: {
                    error_message: 'Please Enter Username',
                },
            });
            return false;
        } else if ('' === asd_email || !emailRegex.test(asd_email)) {
            this.setState({
                error: {
                    error_message: 'Please enter a valid email address.',
                },
            });
            return false;
        } else if ('' === asd_code) {
            this.setState({
                error: {
                    error_message: 'Please Enter the Vendor Display Name',
                },
            });
            return false;
        } else if ('' !== asd_password || '' !== asd_conf_password) {
            if (asd_conf_password !== asd_password) {
                this.setState({
                    error: {
                        error_message: 'Password and confirm password does not match.',
                    },
                });
                return false;
            }
        } else {
            this.setState({
                error: {
                    error_message: '',
                },
            });
        }
        const get_token = localStorage.getItem('token');
        if (this.state.userId === '' || this.state.userId === null) {
            const requestOptions = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    username: asd_username,
                    password: asd_password,
                    role: userrole,
                    email: asd_email,
                    first_name: asd_firstname,
                    last_name: asd_lastname,
                    user_code: asd_code,
                    cost_type: cost_type,
                }),
            };
            fetch(`./wp-json/wp/v2/users/register`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (200 !== data.code) {
                        this.setState({
                            error: {
                                error_message: data.message,
                            },
                        });
                    } else {
                        this.setState({
                            success: {
                                success_message: data.message,
                            },
                        });

                        this.setState({
                            error: {
                                error_message: '',
                            },
                        });
                        window.location.href = './users';
                    }
                });
        } else {
            let obj = {
                userId: this.state.userId,
                get_token: get_token,
                username: asd_username,
                password: asd_password,
                email: asd_email,
                first_name: asd_firstname,
                last_name: asd_lastname,
                user_code: asd_code,
            };
            let inpersonate = localStorage.getItem('inpersonate');
            let userRole = localStorage.getItem('userRole');
            // if (inpersonate == 'true' && 'administrator' === this.state.currentuserrole) {

            // } else
            if (
                (inpersonate == 'true' && 'administrator' !== this.state.currentuserrole) ||
                userRole != 1
            ) {
                obj.roles = '';
            } else {
                obj.roles = userrole;
            }
            const requestOptionsEdit = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + get_token,
                },
                body: JSON.stringify(obj),
            };
            fetch(`./wp-json/asd/users/update`, requestOptionsEdit)
                .then(response => response.json())
                .then(data => {
                    if (data.code !== 200) {
                        this.setState({
                            error: {
                                error_message: data.message,
                            },
                        });
                    } else {
                        this.setState({
                            success: {
                                success_message: data.message,
                            },
                        });

                        this.setState({
                            error: {
                                error_message: '',
                            },
                        });
                        // localStorage.removeItem("inpersonate_id");

                        const userRole = localStorage.getItem('userRole');
                        if (
                            '1' === userRole &&
                            inpersonate !== 'true' &&
                            window.location.pathname != '/myaccount'
                        ) {
                            window.location.href = './users';
                        } else {
                            window.location.href = './';
                        }
                    }
                });
        }
    }

    render() {
        const error = this.state.error.error_message;
        const success = this.state.success.success_message;
        const userRole = localStorage.getItem('userRole');
        const useStyles = makeStyles(theme => ({
            '@global': {
                body: {
                    backgroundColor: theme.palette.common.paper,
                },
            },
            paper: {
                marginTop: theme.spacing(8),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
            avatar: {
                margin: theme.spacing(1),
                backgroundColor: theme.palette.secondary.main,
            },
            form: {
                width: '100%', // Fix IE 11 issue.
                marginTop: theme.spacing(1),
            },
            button: {
                margin: theme.spacing(13, 0, 2),
                background: 'orange',
            },
            formControl: {
                margin: theme.spacing(1),
                minWidth: 120,
            },
            selectEmpty: {
                marginTop: theme.spacing(2),
            },
        }));
        const classes = useStyles;
        let disabled, roleFlag;
        let submitTitle;
        let title;
        let inpersonate = localStorage.getItem('inpersonate');

        // If roleFlag is set to "disabled", the elements are disabled in the UI.
        if (inpersonate == 'true') {
            roleFlag =
                'administrator' === this.state.currentuserrole && '1' === userRole
                    ? ''
                    : 'disabled';
        } else {
            roleFlag = '1' === userRole ? '' : 'disabled';
        }

        if (this.state.userId !== '' && this.state.userId !== null) {
            disabled = 'disabled';
            title = 'Update User';
            submitTitle = 'Update User';
        } else {
            disabled = '';
            title = 'Add New User';
            submitTitle = 'Add New User';
        }
        return (
            <div className="App login-wrap myaccount">
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <h1 className="mt-8">{title}</h1>
                        {error ? (
                            <CustomizedSnackbars
                                type="error"
                                message={ReactHtmlParser(this.state.error.error_message)}
                            />
                        ) : (
                            ''
                        )}

                        {success ? (
                            <CustomizedSnackbars
                                type="success"
                                message={ReactHtmlParser(this.state.success.success_message)}
                            />
                        ) : (
                            ''
                        )}
                        <form
                            className={classes.form}
                            noValidate
                            id="updateUser"
                            onSubmit={this.state.userId ? this.confirmSubmit : this.handleSubmit}
                            autoComplete="off"
                        >
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="asd_firstname"
                                label="Required"
                                className="login_text"
                                label="First Name"
                                name="asd_firstname"
                                value={this.state.asd_firstname}
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="asd_lastname"
                                label="Required"
                                className="login_text"
                                label="Last Name"
                                name="asd_lastname"
                                value={this.state.asd_lastname}
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="asd_username"
                                label="Required"
                                className="login_text"
                                label="Username"
                                name="asd_username"
                                value={this.state.asd_username}
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                                disabled={disabled}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                required
                                id="asd_email"
                                label="Required"
                                className="login_text"
                                label="Email"
                                name="asd_email"
                                value={this.state.asd_email}
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                                type="email"
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                id="asd_passowrd"
                                label="Required"
                                className="login_text"
                                fullWidth
                                label="Password"
                                type="password"
                                name="asd_password"
                                autoComplete="new-password"
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                id="asd_conf_password"
                                label="Required"
                                className="login_text"
                                fullWidth
                                label="Confirm Password"
                                type="password"
                                name="asd_conf_password"
                                autoComplete="new-password"
                                onChange={this.handleChange.bind(this)}
                                //autoFocus
                            />
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                fullWidth
                                margin="normal"
                            >
                                <InputLabel ref="" id="demo-simple-select-outlined-label">
                                    Role
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    className="user_role"
                                    id="demo-simple-select-outlined"
                                    value={this.state.userrole}
                                    onChange={this.handleSelectChange.bind(this)}
                                    disabled={roleFlag}
                                >
                                    <MenuItem value="administrator">Administrator</MenuItem>
                                    <MenuItem value="subscriber">Partner</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                id="asd_code"
                                label="Required"
                                className="login_text"
                                fullWidth
                                label="Vendor Display Name"
                                name="asd_code"
                                value={this.state.asd_code}
                                onChange={this.handleChange.bind(this)}
                                disabled={roleFlag}
                                //autoFocus
                            />
                            <FormControl
                                variant="outlined"
                                className={classes.formControl}
                                fullWidth
                                margin="normal"
                            >
                                <InputLabel ref="" id="simple-select-outlined-label">
                                    Cost Type
                                </InputLabel>
                                <Select
                                    labelId="simple-select-outlined-label"
                                    className="user_role"
                                    id="simple-select-outlined"
                                    value={this.state.cost_type}
                                    onChange={this.handleSelectCostTypeChange.bind(this)}
                                    disabled={roleFlag}
                                >
                                    <MenuItem value="Cost Per Action">Cost Per Action</MenuItem>
                                    <MenuItem value="Revenue Share">Revenue Share</MenuItem>
                                    <MenuItem value="Multiple">Multiple</MenuItem>
                                </Select>
                            </FormControl>
                            <div className="btn-container">
                                <Button
                                    type="submit"
                                    // semiWidth
                                    variant="contained"
                                    color="primary"
                                    className="login-btn form-btn"
                                >
                                    {submitTitle}
                                </Button>
                                <Button
                                    type="button"
                                    //fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="cancel-btn form-btn"
                                    onClick={this.handleCancelSubmit.bind(this)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                    <Box mt={8}></Box>
                </Container>
            </div>
        );
    }
}

export default CreateEdit;
